<template>
  <div>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
    <div
      class="responsive-print"
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'a4-standard-portrait-page':'a4-standard-landscape-page':field.temp_prop.orientation==0?'a5-standard-portrait-page':'a5-standard-landscape-page'"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    >
      <div
        class="print-template"
        :style="{'font-size':(field.temp_prop.font_size||8)+'pt','color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000','background':field.temp_prop.hasOwnProperty('bg_color')&&field.temp_prop.bg_color.show?field.temp_prop.bg_color.value.hex:'#fff'}"
      >
        <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
          <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
            <!-- Organization Details -->
            <div>
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
                style="margin-bottom:1px;font-weight:500;"
              >Shanki Systems India Pvt Ltd</div>

              <div
                v-if="field.header_prop.show_org_addr"
                class="custom-invoice-address"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
              >
                <p>JKR Tower</p>
                <p>5/4 Moonlight Garden</p>
                <p>Coimbatore Tamil Nadu</p>
                <p>India 641048</p>
                <p>Mail: admin@shanki.com</p>
                <p>{{field.header_prop.phone}}: 76639488488</p>
                <!-- <p v-if="field.header_prop.hasOwnProperty('fax')">{{field.header_prop.fax}}: 123123</p> -->
                <p style="margin-bottom:0px;">GSTIN: 12ASDF12345A1Z0</p>
              </div>
            </div>
            <!-- Organization Logo -->
            <div>
              <!-- Max width for Logo Block -->

              <!-- Logo Image -->
              <img
                v-if="field.header_prop.show_logo&&imageSrc!=''"
                :src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
              <img
                v-if="field.header_prop.show_logo&&imageSrc==''"
                src="@/assets/logo/Shanki-logo.png"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
            </div>
          </div>
          <hr />
          <div class="invoice-second-block" style="padding-bottom:20px">
            <div
              v-if="field.receipt_info.doc_title.show"
              style="text-align:center;word-break:break-all;"
              :style="{'font-size':field.receipt_info.doc_font_size+'pt'}"
            >
              <u style="color:rgba(0, 0, 0, 0.46) !important">
                <span
                  :style="{'color':field.receipt_info.doc_font_color.hex}"
                >{{field.receipt_info.doc_title.label}}</span>
              </u>
            </div>
          </div>
          <div class="invoice-third-block" style="display:flex;padding-top:30px">
            <table style="width: 70%;float: left;">
              <thead>
                <th style="width:35%;float:left;"></th>
                <th style="width:65%;"></th>
              </thead>
              <tbody>
                <tr v-if="field.receipt_info.doc_no.show">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.receipt_info.doc_no.label}}</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>1</b>
                    </div>
                  </td>
                </tr>
                <tr v-if="field.receipt_info.doc_date.show">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.receipt_info.doc_date.label}}</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>{{getDateFormat(new Date())}}</b>
                    </div>
                  </td>
                </tr>
                <tr v-if="field.receipt_info.doc_ref_no.show">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.receipt_info.doc_ref_no.label}}</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>12345</b>
                    </div>
                  </td>
                </tr>
                <tr v-if="field.receipt_info.doc_pymt_mode.show">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >{{field.receipt_info.doc_pymt_mode.label}}</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>Cash</b>
                    </div>
                  </td>
                </tr>
                <tr v-if="$route.params.id == 23">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >Place Of Supply</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>Tamil Nadu (33)</b>
                    </div>
                  </td>
                </tr>
                <tr v-if="$route.params.id == 23">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >CGST [12.00%]</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>
                        <div style="display:inline-block">
                          <span
                            style="margin-left:5px !important;margin-right:5px !important"
                            :class="{'float-right':field.receipt_info.currency_syb==2}"
                          >{{orgCurrencySymbol}}</span>40.04
                        </div>
                      </b>
                    </div>
                  </td>
                </tr>
                <tr v-if="$route.params.id == 23">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >SGST [12.00%]</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>
                        <div style="display:inline-block">
                          <span
                            style="margin-left:5px !important;margin-right:5px !important"
                            :class="{'float-right':field.receipt_info.currency_syb==2}"
                          >{{orgCurrencySymbol}}</span>40.04
                        </div>
                      </b>
                    </div>
                  </td>
                </tr>
                <tr v-if="field.receipt_info.show_amt_wrd">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >Amount Received In Words</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>Rupees Seven Thousand Eight Hundred And Fifty Nine And Four Paise Only</b>
                    </div>
                  </td>
                </tr>
                <tr v-if="$route.params.id == 23">
                  <td
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                  >Description of Supply</td>
                  <td>
                    <div style="border-bottom:1px solid #eee;width:100%;padding-bottom:2px;">
                      <b>Brochure Design</b>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <table style="width: 30%;">
              <tbody>
                <tr>
                  <td>
                    <div
                      :style="{'color':field.receipt_info.amt_recv_font_color.hex,'background':field.receipt_info.amt_recv_bg_color.show?field.receipt_info.amt_recv_bg_color.value.hex:'#fff'}"
                      style="text-align:center;word-break: break-all;float:right;padding: 34px 15px;"
                    >
                      <span
                        :style="{'font-size':(field.temp_prop.font_size||8)+'pt'}"
                      >{{field.receipt_info.amt_recv_label}}</span>
                      <br />
                      <span :style="{'font-size':field.receipt_info.amt_recv_font_size+'pt'}">
                        <span
                          style="margin-left:5px !important;margin-right:5px !important"
                          :class="{'float-right':field.receipt_info.currency_syb==2}"
                        >{{orgCurrencySymbol}}</span>
                        7,859.04
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="invoice-fourth-block" style="display: flow-root;">
            <div class="signature-block">
              <div style="float:right;width:max-content" v-if="field.receipt_info.signature.show">
                <div
                  class="semi-bold text-right mb-2"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                >{{field.receipt_info.signature.label}}</div>
                <hr style="border-color:#000;margin-bottom:0px;margin-top: 2.5rem" />
              </div>
              <div
                style="float:left;width:max-content"
                v-if="field.receipt_info.hasOwnProperty('add_signature')&&field.receipt_info.add_signature.show"
              >
                <div
                  class="semi-bold text-right mb-2"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                >{{field.receipt_info.add_signature.label}}</div>
                <hr style="border-color:#000;margin-bottom:0px;margin-top: 2.5rem" />
              </div>
            </div>
          </div>
          <div
            class="invoice-third-block"
            style="padding-top:30px"
            v-if="field.receipt_info.cus_recv_from.show"
          >
            <p :style="{'color':field.temp_prop.label_color.hex}">
              <b>{{field.receipt_info.cus_recv_from.label}}</b>
            </p>
            <b
              :style="{'font-size':field.receipt_info.bill_addr_font_size+'pt','color':field.receipt_info.bill_addr_font_color.hex}"
            >Shanki</b>
            <p style="margin:0px">JKR Tower</p>
            <p style="margin:0px">5/4 Moonlight Garden</p>
            <p style="margin:0px">Coimbatore Tamil Nadu</p>
            <p style="margin:0px">India 641048</p>
            <p style="margin-bottom:0px;">GSTIN: 12ASDF12345A1Z0</p>
          </div>
          <hr />
          <div class="invoice-fourth-block" style="padding-top:10px">
            <table>
              <tbody>
                <tr>
                  <td v-if="field.receipt_info.doc_pymt_refund.show">
                    <div style="border-right: 1px solid #ededed;padding-right:20px">
                      <p
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        style="font-size:13px;font-weight:bold"
                      >{{field.receipt_info.doc_pymt_refund.label}}</p>
                      <p style="text-align:center">
                        <span style="display:inline-block">
                          <span
                            style="margin-left:5px !important;margin-right:5px !important"
                            :class="{'float-right':field.receipt_info.currency_syb==2}"
                          >{{orgCurrencySymbol}}</span>5.00
                        </span>
                      </p>
                    </div>
                  </td>
                  <td v-if="field.receipt_info.doc_over_pymt.show">
                    <div>
                      <p
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                        style="font-size:13px;font-weight:bold"
                      >{{field.receipt_info.doc_over_pymt.label}}</p>
                      <p style="text-align:center">
                        <span style="display:inline-block">
                          <span
                            style="margin-left:5px !important;margin-right:5px !important"
                            :class="{'float-right':field.receipt_info.currency_syb==2}"
                          >{{orgCurrencySymbol}}</span>25.00
                        </span>
                      </p>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <hr />
          <div class="invoice-fifth-block" v-if="field.inv_details.label.show_inv_detail">
            <p
              :style="{'color':field.inv_details.layout.pymt_font_color.hex,'font-size':field.inv_details.layout.pymt_font_size+'pt'}"
            >{{field.inv_details.label.pymt_for_label}}</p>
            <table style="width:100%">
              <thead
                :style="{'background':field.inv_details.layout.header_bg_color.show?field.inv_details.layout.header_bg_color.value.hex:'#fff','color':field.inv_details.layout.header_font_color.hex,'font-size':field.inv_details.layout.header_font_size+'pt'}"
              >
                <th
                  style="padding:5px 10px 5px 10px;word-wrap: break-word;"
                  v-if="field.inv_details.label.inv_no.show"
                >{{field.inv_details.label.inv_no.label}}</th>
                <th
                  style="padding:5px 10px 5px 10px;word-wrap: break-word;"
                  v-if="field.inv_details.label.inv_date.show"
                >{{field.inv_details.label.inv_date.label}}</th>
                <th
                  style="padding:5px 10px 5px 10px;word-wrap: break-word;text-align:right"
                  v-if="field.inv_details.label.inv_amt.show"
                >{{field.inv_details.label.inv_amt.label}}</th>
                <th
                  style="padding:5px 10px 5px 10px;word-wrap: break-word;text-align:right"
                  v-if="field.inv_details.label.hasOwnProperty('withholding_tax')&&field.inv_details.label.withholding_tax.show"
                >{{field.inv_details.label.withholding_tax.label}}</th>
                <th
                  style="padding:5px 10px 5px 10px;word-wrap: break-word;text-align:right"
                  v-if="field.inv_details.label.pymt_amt.show"
                >{{field.inv_details.label.pymt_amt.label}}</th>
              </thead>
              <tbody
                :style="{'font-size':(field.inv_details.layout.item_row_font_size||8)+'pt','color':field.inv_details.layout.hasOwnProperty('item_row_font_color')?field.inv_details.layout.item_row_font_color.hex:'#000','background':field.inv_details.layout.hasOwnProperty('item_row_bg_color')&&field.inv_details.layout.item_row_bg_color.show?field.inv_details.layout.item_row_bg_color.value.hex:'#fff'}"
              >
                <tr
                  :style="{'border-bottom':field.inv_details.layout.table_border.show+'px'+' solid '+field.inv_details.layout.table_border.value.hex}"
                >
                  <td
                    style="padding:5px 10px 5px 10px;word-wrap: break-word;"
                    v-if="field.inv_details.label.inv_no.show"
                  >INV-0001</td>
                  <td
                    style="padding:5px 10px 5px 10px;word-wrap: break-word;"
                    v-if="field.inv_details.label.inv_date.show"
                  >{{getDateFormat(new Date())}}</td>
                  <td
                    style="padding:5px 10px 5px 10px;word-wrap: break-word;text-align:right"
                    v-if="field.inv_details.label.inv_amt.show"
                  >
                    <span
                      style="margin-left:5px !important;margin-right:5px !important"
                      :class="{'float-right':field.receipt_info.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span>100
                  </td>
                  <td
                    style="padding:5px 10px 5px 10px;word-wrap: break-word;text-align:right"
                    v-if="field.inv_details.label.hasOwnProperty('withholding_tax')&&field.inv_details.label.withholding_tax.show"
                  >
                    <span
                      style="margin-left:5px !important;margin-right:5px !important"
                      :class="{'float-right':field.receipt_info.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span>25
                  </td>
                  <td
                    style="padding:5px 10px 5px 10px;word-wrap: break-word;text-align:right"
                    v-if="field.inv_details.label.pymt_amt.show"
                  >
                    <span
                      style="margin-left:5px !important;margin-right:5px !important"
                      :class="{'float-right':field.receipt_info.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span>30
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff','color':field.footer_prop.hasOwnProperty('footer_color')?field.footer_prop.footer_color.hex:'#000','font-size':(field.footer_prop.footer_font_size||7)+'pt'}"
        ></div>
      </div>
    </div>
    <!-- End of A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapGetters } from "vuex";
export default {
  props: ["list", "id"],
  data() {
    return {
      field: JSON.parse(JSON.stringify(this.list)),
      imageSrc: ""
    };
  },
  methods: {
    preview(eve) {
      this.field = JSON.parse(JSON.stringify(eve));
    }
  },
  created() {
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : "";
  },
  mounted() {
    EventBus.$on("preview", this.preview); // to trigger the method from parentcomponent
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "inv_settings_details", "orgCurrencySymbol"])
  }
};
</script>



<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page {
  width: 21cm;
  min-height: 29.7cm;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page {
  width: 29.7cm;
  min-height: 21cm;
}
//A5 standard portrait
#a5-standard-portrait-page {
  width: 14.8cm;
  min-height: 21cm;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page {
  width: 21cm;
  min-height: 14.8cm;
}

#a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}

#a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template {
  zoom: 80%;
}

.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
@media (min-width: 10px) and (max-width: 768px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 36%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 26%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 52%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 36%;
  }
}
@media (min-width: 769px) and (max-width: 1024px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 50%;
  }

  #a4-standard-landscape-page.responsive-print {
    zoom: 35%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 70%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 50%;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 70%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 55%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 100%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 80%;
  }
}
@media (min-width: 1281px) and (max-width: 1366px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 80%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 62%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 100%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 75%;
  }
}
@media (min-width: 1367px) and (max-width: 1440px) {
  #a4-standard-portrait-page.responsive-print {
    zoom: 75%;
  }
  #a4-standard-landscape-page.responsive-print {
    zoom: 70%;
  }
  #a5-standard-portrait-page.responsive-print {
    zoom: 85%;
  }
  #a5-standard-landscape-page.responsive-print {
    zoom: 85%;
  }
}
</style>
